import { render } from "./CompleteModal.vue?vue&type=template&id=73fbdf00&scoped=true"
import script from "./CompleteModal.vue?vue&type=script&lang=js"
export * from "./CompleteModal.vue?vue&type=script&lang=js"

import "./CompleteModal.vue?vue&type=style&index=0&id=73fbdf00&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fbdf00"]])

export default __exports__